<script>
const TONES = {
	draft: 'neutral',
	new: 'neutral',
	subject_signed: 'info',
	tir_signed: 'success',
	canceled_by_tir: 'warning',
	rejected: 'danger',
	active: 'success',
	suspended: 'warning',
	terminated: 'danger',
	overdue: 'danger',
	missing: 'neutral',
}

const ICONS = {
	success: 'M5 12.5l4.5 4.5L19 7',
	warning: 'M12 7v6M12 16.5v.5',
	danger: 'M7 7l10 10M17 7L7 17',
	info: 'M12 6.5V12l3.5 2',
	neutral: 'M8 12h8',
}

export default {
	name: 'AqStatus',
	props: {
		value: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: '',
		},
		tone: {
			type: String,
			default: '',
		},
	},
	computed: {
		resolvedTone() {
			return this.tone || TONES[this.value] || 'neutral'
		},
		icon() {
			return ICONS[this.resolvedTone]
		},
	},
}
</script>

<template>
	<span class="aq-badge" :class="`aq-badge--${resolvedTone === 'info' ? 'info' : resolvedTone}`">
		<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true">
			<circle v-if="resolvedTone === 'info'" cx="12" cy="12" r="9" />
			<path :d="icon" />
		</svg>
		{{ label }}
	</span>
</template>
